<app-breadcrumb [master]="'Administracja'" [parentName]="'Hiperio'" [name]="'Loginy'"></app-breadcrumb>
<div class="credentials-job-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="document-list-filters">
    <app-dict
      [multiple]="false" [dictType]="'hiperio_credentials_job_type'"
      [label]="'Typ'" class="credentials-job-list-filter"
      [(ngModel)]="initialFilters.type" name="type"
    ></app-dict>

    <app-dict-partners
      [multiple]="false" [label]="'Partner'"
      class="credentials-job-list-filter"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <app-dict-ofwcas
      [multiple]="false" label="OFWCA"
      class="credentials-job-list-filter "
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
    ></app-dict-ofwcas>


    <app-datepicker
      class="credentials-job-list-filter"
      label="Data utworzenia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="credentials-job-list-filter"
      label="Data utworzenia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

    <app-dict
      [multiple]="false" [dictType]="'job_status'"
      [label]="'Status'" class="credentials-job-list-filter"
      [(ngModel)]="initialFilters.status" name="status"
    ></app-dict>

    <app-dict-regionals
      [multiple]="false" label="Regionalny (majątek)"
      class="credentials-job-list-filter"
      [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
    ></app-dict-regionals>

  </form>

  <div class="credentials-job-buttons">
    <button *ngIf=" (userPermissions | async)?.hiperio.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async)?.hiperio.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport dostępów mieszanych</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>
    <table mat-table [dataSource]="jobs" multiTemplateDataRows  >

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef> Typ </th>
        <td mat-cell *matCellDef="let element">
          {{element?.type?.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef> Data utworzenia </th>
        <td mat-cell *matCellDef="let element">
          {{element.createdAt | date:'y-MM-dd HH:mm'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="createdBy">
        <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.calledBy">
            <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.calledBy.uuid]">{{element.calledBy?.firstName}} {{element.calledBy?.lastName}}</a>
          </ng-container>
          <ng-container *ngIf="!element.calledBy">
            System
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="ofwca">
        <th mat-header-cell *matHeaderCellDef> OFWCA </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.ofwca">
            <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">{{element.ofwca?.fullName}}</a>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="registration">
        <th mat-header-cell *matHeaderCellDef> Rejestracja </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.registration">
            <a class="default-link" [routerLink]="['/rejestracje/szczegoly', element.registration?.uuid]">
              {{element.registration?.insuranceCompany?.name}}  {{ element.registration?.ofwca?.fullName }}
            </a>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let element">
          <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'" [matTooltip]=element.output >
            {{element.status.name}}
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>  </th>
        <td mat-cell *matCellDef="let element">
          <button *ngIf="element.status?.key!== COMMISSION_JOB_STATUS_IN_SUCCESS " [disabled]="!(userPermissions | async).hiperio.write"  (click)="restart(element.uuid)" mat-stroked-button  color="warn">Odśwież status</button>
        </td>
      </ng-container>

        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="expanded-row-td">
                <div class="expanded-data" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                    <div fxFlex="100"  fxLayoutGap="15px" *ngIf="element == expandedElement">

                        <div class="note-box" *ngFor="let company of parseNote(element.note) | keyvalue">

                            <h3>{{ company.key }}</h3>

                            <div class="note-row"
                                 *ngFor="let field of company.value | keyvalue">

                                <span style=" padding-right: 5px">{{ field.key }}:</span>

                                <strong  style="word-break: break-all">
                                    {{ field.value ? field.value : '-' }}
                                </strong>

                            </div>

                        </div>

                    </div>

                </div>
            </td>
        </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr class="table-row"
            mat-row *matRowDef="let element; let row; columns: displayedColumns;"
            [class.expanded-row]="expandedElement === element"
            [class.not-expanded-row]="expandedElement && expandedElement !== element"
            (click)="expandElement(element)"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expanded-data-row"></tr>

    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
  </div>
